<form [formGroup]="form" id="otp-input-form">
  <div class="input-row">
    <input
      #input
      class="token-input"
      id="input"
      type="text"
      maxlength="6"
      inputmode="numeric"
      pattern="[0-9]"
      formControlName="token"
      [autocomplete]="IOS ? 'one-time-code' : 'off'"
      (paste)="onPaste($event)"
    />
    <div
      class="underline"
      [class.invalid]="form.controls.token.invalid && showError"
    ></div>
  </div>
</form>
